<app-lms-modal-frame [title]="'Region Details'" [pageHeadWidth]="300">
  <div modal-body>
    <div class="container-fluid">
      <div class="row center-screen">
        <div class="center-container">
          <form [formGroup]="regionForm">

            <div class="row center-screen">
              <table class="table table-striped table-auto table-sm shadow-2-strong p-1">
                <tbody class="field-4column-label">
                  <tr>
                    <td class="align-items-center text-center w-50">
                      Region name: &nbsp;
                      <input formControlName="name" type="text" lmsNoSpecials style="max-width: 150px;">
                      <div *ngIf="regionForm?.controls?.name?.errors?.NoSpecials">
                        <small class="text-danger">
                          Special characters are not allowed.
                        </small>
                      </div>
                      <!-- <div *ngIf="areaForm.controls.area.errors?.required && submitted" class="error-label">
                    Area is required
                  </div> -->
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <table class="table table-striped table-fixed table-sm">
                        <caption>Manage areas in this region</caption>
                        <thead class="table-center-header" style="background-color: white;" color="primary">
                          <tr>
                            <th>Code</th>
                            <th>Area</th>
                            <th>Edit</th>
                          </tr>
                        </thead>
                        <tbody class="center-fields">
                          <tr *ngFor="let areaRec of region_Ar.areas;">
                            <td>{{areaRec.id}}</td>
                            <td>{{areaRec.name}}</td>
                            <td>
                              <button class="btn btn-floating btn-icon fs-5 fas" mdbRipple
                                (click)="selectAreaEdit(areaRec)">
                                <i class="fas fa-xs fa-fw fa-pen-to-square"></i></button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <button class="btn btn-primary btn-sm button-add-row mx-2" mdbRipple type="button"
                                (click)="findAllAreas()">Move an area to this
                                region</button>

                              <button type="button" class="btn btn-primary btn-sm" (click)="createNewArea()">
                                Create a new area </button>
                            </td>
                          </tr>

                          <tr *ngIf="(regionAreaSel?.length ?? 0) > 0">
                            <td>
                              Add area:
                            </td>
                            <td colspan="2">
                              <span>
                                <mdb-select class="select table-control has-cell-control" formControlName="selArea">
                                  <mdb-option *ngFor="let ar of regionAreaSel" [value]="ar">{{ ar.name }}</mdb-option>
                                </mdb-select>

                                <div class="text-wrap">
                                  <small class="text-warning">
                                    Adding an area will remove the area from the area's current region!
                                  </small>
                                </div>
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </form>
        </div>
      </div>
    </div>

  </div>

  <div modal-actions class="lms-action-bar">
    <button class="btn btn-primary" mdbRipple (click)="dialogRef.close()"> Close
    </button>
    <button class="btn btn-primary" mdbRipple (click)="saveRegion()">Save
    </button>
  </div>
</app-lms-modal-frame>
